export default __webpack_public_path__ + "static/media/celebration.289a22f6.png";